import PropTypes from 'prop-types';

import CarouselFeatured from './CarouselFeatured';
import CarouselHero from './CarouselHero';
import CarouselNormal from './CarouselNormal';
import CarouselSlider from './CarouselSlider';
import CarouselAsymmetric from './CarouselAsymmetric';

import { CtfCarouselStyle } from '@/utils/constants';

function Carousel({ assets, carouselContentStyle, entries, fields }) {
  // @TODO: Improve variable spreading and type checking.
  const { carouselStyle, pages } = fields;
  const style = carouselStyle || CtfCarouselStyle.NORMAL;

  if (pages) {
    fields.cards = pages;
    entries = [
      ...entries,
      ...pages.map((p) => ({
        ...p,
        fields: {
          primaryCTA: p.fields.slug,
          tags: p.fields.tags,
          title: p.fields.title,
          text: p.fields.previewText ?? null,
          cloudinaryAssets: p.fields.cloudinaryPreviewAssets ?? null,
          dynamicAsset: p.fields.previewAsset ?? null,
        },
      })),
    ];
  }

  if (
    style === CtfCarouselStyle.FEATURED ||
    style === CtfCarouselStyle.FEATURED_FULL
  ) {
    return (
      <CarouselFeatured
        fields={fields}
        assets={assets}
        entries={entries}
        carouselContentStyle={carouselContentStyle}
      />
    );
  } else if (
    style === CtfCarouselStyle.FEATURED_ASYMMETRIC ||
    style === CtfCarouselStyle.FEATURED_ASYMMETRIC_FULL
  ) {
    return (
      <CarouselAsymmetric
        fields={fields}
        assets={assets}
        entries={entries}
        carouselContentStyle={carouselContentStyle}
      />
    );
  } else if (style === CtfCarouselStyle.HERO) {
    return (
      <CarouselHero
        fields={fields}
        assets={assets}
        carouselContentStyle={carouselContentStyle}
        entries={entries}
      />
    );
  } else if (style === CtfCarouselStyle.SLIDER) {
    return (
      <CarouselSlider
        fields={fields}
        assets={assets}
        carouselContentStyle={carouselContentStyle}
        entries={entries}
      />
    );
  }

  return (
    <CarouselNormal
      carouselContentStyle={carouselContentStyle}
      fields={fields}
      assets={assets}
      entries={entries}
    />
  );
}

// @TODO: define real props for the Carousel based on it requirements
Carousel.propTypes = {
  assets: PropTypes.array,
  carouselContentStyle: PropTypes.object,
  entries: PropTypes.array,
  fields: PropTypes.object,
};

Carousel.defaultProps = {
  assets: [],
  carouselContentStyle: {
    compactSpace: false,
    hasBackground: false,
    linkStyle: '',
  },
  entries: [],
  fields: null,
};

export default Carousel;
